import Bowser from "bowser";

let browserInfo = {};

if (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent) {
    const result = Bowser.parse(window.navigator.userAgent);
    const browserName = (result.browser && result.browser.name) || "";
    const normalizedBrowserName = browserName.toLowerCase();

    browserInfo = {
        name: browserName,
        version: result.browser.version,
        os: result.os.name,
        osVersion: result.os.version,
        platformType: result.platform.type,
        isMobile: result.platform.type !== "desktop",
        isDesktop: result.platform.type === "desktop",
        isChrome: normalizedBrowserName === "chrome" || normalizedBrowserName === "chromium",
        isSafari: normalizedBrowserName === "safari",
        isFirefox: normalizedBrowserName === "firefox",
        isEdge: normalizedBrowserName.includes("edge"),
        full: result,
        ua: window.navigator.userAgent
    };
} else {
    console.warn('Phát hiện trình duyệt thất bại: window hoặc navigator.userAgent không khả dụng.');
}

const VueBrowserDetect = {
    install(Vue) {
        Vue.prototype.$browserDetect = browserInfo;
    },
};

export default VueBrowserDetect;
export { browserInfo };
